export default "__VITE_ASSET__ca8cddb8__"